import {Injectable} from '@angular/core';
import {HubConnection, HubConnectionBuilder, HubConnectionState, LogLevel} from '@microsoft/signalr';

@Injectable({
  providedIn: 'root'
})
export class SignalrService {
  private hubConnection: HubConnection;

  constructor() {
    // Initialize the SignalR connection
    console.log('Build hub connection from signalr.service')
    this.hubConnection = new HubConnectionBuilder()
      .withUrl('https://mcube-webapi-afeee8b9cxdaapbu.westeurope-01.azurewebsites.net/notifications')  // Replace with your SignalR hub URL
      .configureLogging(LogLevel.Information)  // Set logging level (optional)
      .build();
  }

  // Start connection
  startConnection(callback: (connection: HubConnection) => void): void {
    console.log('Start signalR connection from signalr.service')
    this.hubConnection
      .start()
      .then(() => {
        console.log('SignalR connection established');

        return callback(this.hubConnection);
      })
      .catch(err => {
        console.error('Error establishing SignalR connection: ', err);
      });
  }

  // Listen to an event from the SignalR hub
  addListener(eventName: string, callback: (data: any) => void): void {
    this.hubConnection.on(eventName, callback);
  }

  // Stop the SignalR connection
  stopConnection(): void {
    if (this.hubConnection.state === HubConnectionState.Connected) {
      this.hubConnection.stop()
        .then(() => {
          console.log('SignalR connection stopped');
        })
        .catch(err => {
          console.error('Error stopping SignalR connection: ', err);
        });
    }
  }
}
